module.exports = __webpack_public_path__ + "static/media/interior3.50fe7257.jpeg";